import { render, staticRenderFns } from "./createNotifyEventDia.vue?vue&type=template&id=615c082d&scoped=true&"
import script from "./createNotifyEventDia.vue?vue&type=script&lang=js&"
export * from "./createNotifyEventDia.vue?vue&type=script&lang=js&"
import style0 from "./createNotifyEventDia.vue?vue&type=style&index=0&id=615c082d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c082d",
  null
  
)

export default component.exports